export default __webpack_public_path__ + "static/media/pictures-icon.9116d8fa.svg";